/**
 * Registers the app-shell service worker (public/sw.js) for offline support.
 * Skipped in dev — a cached service worker would otherwise intercept Vite's
 * HMR/module requests and cause confusing stale-content bugs while developing.
 */
export function registerServiceWorker() {
  if (import.meta.env.DEV) return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      console.warn("[sw] Registration failed:", err);
    });
  });
}
